import React from 'react';
import { ArrowRight, Lock } from 'lucide-react';
import { Card, Badge, ScoreRing, Button } from './ds';
import CategoryCard from './CategoryCard';
import { getRisk } from '../utils/posture';
import { useIsMobile } from '../hooks/useMediaQuery';

const FONT = "'IBM Plex Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";

// Ergebnis des anonymen CyberRisikoChecks (AUD-53): Gesamt-Score + Kategorien-
// Breakdown sofort sichtbar. Der vollständige PDF-Bericht bleibt hinter Registrierung/
// Abo (Report-Gating ist eine eigene Story) — hier nur der Registrierungs-CTA.
const AnonymousResult = ({ posture, onRegister }) => {
  const isMobile = useIsMobile();
  if (!posture) return null;

  const overall = getRisk(posture.overallScore);
  const categories = posture.categories || [];

  return (
    <div style={{ maxWidth: 960, margin: '0 auto', fontFamily: FONT }}>
      {/* Hero: Gesamt-Score */}
      <Card padding={0} style={{ marginBottom: 20 }}>
        <div style={{
          display: 'flex', flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center', gap: isMobile ? 20 : 32, padding: isMobile ? '28px 24px' : '36px 40px',
        }}>
          <ScoreRing value={posture.overallScore} label="Gesamt" size={isMobile ? 120 : 150} stroke={12} tone={overall.tone} />
          <div style={{ flex: 1, textAlign: isMobile ? 'center' : 'left' }}>
            <div style={{ marginBottom: 10 }}>
              <Badge tone={overall.tone}>{overall.label}</Badge>
            </div>
            <h1 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 700, color: '#101623', letterSpacing: '-0.011em' }}>
              Ihr Ergebnis liegt vor
            </h1>
            <p style={{ margin: 0, fontSize: 14, color: '#667085', lineHeight: 1.6 }}>
              Basierend auf Ihren Angaben zum DIN SPEC 27076 CyberRisikoCheck.
              {typeof posture.totalFindings === 'number' && (
                <> Es wurden <strong style={{ color: '#101623' }}>{posture.totalFindings}</strong> offene Befunde
                {' '}über {categories.length} Themenbereiche ermittelt.</>
              )}
            </p>
          </div>
        </div>
      </Card>

      {/* Kategorien-Breakdown */}
      <h2 style={{ margin: '0 0 12px', fontSize: 15, fontWeight: 700, color: '#101623' }}>
        Themenbereiche
      </h2>
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fill, minmax(260px, 1fr))',
        gap: 14, marginBottom: 24,
      }}>
        {categories.map((cat) => (
          <CategoryCard key={cat.name} name={cat.name} score={cat.score} findings={cat.findings} />
        ))}
      </div>

      {/* Registrierungs-CTA — vollständiger Bericht ist gated */}
      <Card padding={0}>
        <div style={{
          padding: isMobile ? '24px 20px' : '28px 32px',
          display: 'flex', flexDirection: isMobile ? 'column' : 'row',
          alignItems: isMobile ? 'stretch' : 'center', gap: 16,
          background: '#F2F6FE', borderRadius: 'inherit',
        }}>
          <div style={{
            width: 48, height: 48, borderRadius: 12, flexShrink: 0,
            background: '#DCE7FB', color: '#1E4FBE',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: isMobile ? '0 auto' : 0,
          }}>
            <Lock width={22} height={22} />
          </div>
          <div style={{ flex: 1, textAlign: isMobile ? 'center' : 'left' }}>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#101623', marginBottom: 4 }}>
              Vollständigen Bericht sichern
            </div>
            <div style={{ fontSize: 13, color: '#475569', lineHeight: 1.5 }}>
              Ihr vollständiger PDF-Sicherheitsbericht nach DIN SPEC 27076 mit detaillierten
              Handlungsempfehlungen — nach der kostenlosen Registrierung automatisch per E-Mail
              und jederzeit im Dashboard.
            </div>
          </div>
          <Button size="md" onClick={onRegister} trailingIcon={<ArrowRight width={16} height={16} />}>
            Kostenlosen Report abrufen
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default AnonymousResult;
